import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { viewerApi } from 'app/services/edpApiV1/viewer';

type ViewerDivisions = {
  data: {
    id: number;
    name: string;
    code: string;
  }[];
};

const initialState: ViewerDivisions = {
  data: [
    {
      id: 0,
      name: '',
      code: '',
    },
  ],
};

export const viewerDivisionsSlice = createSlice({
  name: 'viewer/divisions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        viewerApi.endpoints.divisions.matchFulfilled,
        (state, { payload }: PayloadAction<ViewerDivisions>) => payload,
      )
      .addMatcher(viewerApi.endpoints.divisions.matchRejected, () => initialState);
  },
});

const selectViewerDivisions = (state: RootState) => state.entities.viewer.divisions;

export const selectors = { selectViewerDivisions };
export const actions = viewerDivisionsSlice.actions;
export const reducer = viewerDivisionsSlice.reducer;
